<div class="top-div">

<div
  class="file-upload-wrapper"
  [class.success]="uploadSuccess"
  [class.error]="uploadError"
  (drop)="onFileDrop($event)"
  (dragover)="onDragOver($event)"
>
  <input
    type="file"
    accept="image/*"
    (change)="onFileChange($event)"
    hidden
    #fileInput
  />
  <div class="file-dropper" (click)="fileInput.click()">
    <p>click or drag-and-drop</p>
    <div *ngIf="imageName()">
      <div *ngIf="selectedFile || imagePreview">
        <img
          [src]="imagePreview()"
          alt="Image Preview"
          class="image-preview"
        />
        <p>
          <span class="image-name">{{ imageName() }}</span> ({{
            fileSize()
          }} KB)
        </p>
        <mat-icon class="delete-icon" (click)="removeImage()">delete</mat-icon>
      </div>
    </div>
  </div>
</div>

<div *ngIf="selectedFile">
  <button class="upload-button" mat-icon-button (click)="doFileUploadToServer()">
    <mat-icon>upload</mat-icon>
  </button>
</div>


</div>